require('./bootstrap');

require('alpinejs');

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();